export let GLOBAL = {
    url : '/api/'
};
